import {
  Button,
  DatePicker,
  Form,
  Input,
  InputNumber,
  Modal,
  Select,
  Space,
} from "antd";
import axios from "axios";
import React, { useContext, useState } from "react";
import { NotificationInfo, UserInfo } from "../../../../context";
import moment from "moment";
// import { NotificationInfo, UserInfo } from "../../../context";

const PaymentOrder = ({
  closeOriginalTab,
  open,
  close,
  selectedData,
  total,
  getMerchantOrderSaveList,
  getMerchantInvoiceDetails,
}) => {
  const { userData } = useContext(UserInfo);
  const { rerunNotif } = useContext(NotificationInfo);
  const [selectedMethod, setSelectedMethod] = useState("");
  const [selectedCheckDate, setSelectedCheckDate] = useState("");

  const handlePayment = (values) => {
    const formdata = new FormData();
    formdata.append("user_id", userData.data.id);
    formdata.append("invoice_number", selectedData.invoice_number);
    formdata.append(
      "checkdate",
      moment(new Date(selectedCheckDate), "YYYY-MM-DD").format("YYYY-MM-DD")
    );
    for (const name in values) {
      formdata.append(name, values[name]);
    }
    axios
      .post("user/commissary/invoice-payment", formdata)
      .then((response) => {
        const data = response.data;
        if (data === "success") {
          rerunNotif("success", "Payment successful.");
          setTimeout(() => {
            closeOriginalTab();
            close();
            getMerchantOrderSaveList();
            getMerchantInvoiceDetails();
          }, 1000);
        }
      })
      .catch((error) => {
        console.log("Error: ", error);
      });
  };

  return (
    <Modal
      title=""
      open={open}
      onCancel={() => close()}
      footer={null}
      width={350}
    >
      <Form
        layout="vertical"
        name="basic"
        initialValues={{
          amount: total,
        }}
        onFinish={handlePayment}
        autoComplete="off"
      >
        <Space
          direction="vertical"
          style={{ width: "100%", margin: 0, marginTop: 20 }}
        >
          <Form.Item
            name="payment_method"
            label="Payment Method"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <Select
              placeholder="Select payment method"
              //   onChange={handleGetCityByProvince}
              onChange={(e) => {
                setSelectedMethod(e);
              }}
              size="large"
              showSearch
            >
              <Select.Option value="cash">Cash</Select.Option>
              <Select.Option value="check">Check</Select.Option>
            </Select>
          </Form.Item>

          {selectedMethod === "check" && (
            <>
              <Form.Item
                name="bank_name"
                label="Bank Name"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input
                  placeholder="Set bank name"
                  size="large"
                  //   value={selectedDeliveredUnit}
                  //   onChange={(e) => setSelectedDeliveredUnit(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name="account_no"
                label="Account No."
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input
                  placeholder="Set account number"
                  size="large"
                  //   value={selectedDeliveredUnit}
                  //   onChange={(e) => setSelectedDeliveredUnit(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name="check_no"
                label="Check No."
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <Input
                  placeholder="Set check number"
                  size="large"
                  //   value={selectedDeliveredUnit}
                  //   onChange={(e) => setSelectedDeliveredUnit(e.target.value)}
                />
              </Form.Item>

              <Form.Item
                name="check_date"
                label="Check Date"
                rules={[
                  {
                    required: true,
                    message: "Required",
                  },
                ]}
              >
                <DatePicker
                  format={"MM-DD-YYYY"}
                  size="large"
                  style={{ width: "100%" }}
                  //   value={selectedCheckDate}
                  onChange={(date, dateString) =>
                    setSelectedCheckDate(dateString)
                  }
                />
              </Form.Item>
            </>
          )}

          <Form.Item
            name="amount"
            label="Amount"
            rules={[
              {
                required: true,
                message: "Required",
              },
            ]}
          >
            <InputNumber
              min={0.01}
              max={999999999999}
              initialvalues={0}
              size="large"
              style={{ width: "100%" }}
              step="0.01"
              disabled
              // size="large"
            />
          </Form.Item>
        </Space>

        <Form.Item style={{ marginTop: "20px" }}>
          <Button
            type="primary"
            htmlType="submit"
            style={{ width: "100%", borderRadius: "20px" }}
          >
            Process
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
};

export default PaymentOrder;
